import { FileType } from '../types';
import { FiAppSettings } from '@fi-shared/fi-app-settings';
import { isDefined } from '@uirouter/core';

export const FiMimeTypesMap: {
    [propName: number]: string;
} = {};

FiMimeTypesMap[FileType.Image] = 'image/*';
FiMimeTypesMap[FileType.Movie] = 'video/mp4, video/quicktime';
FiMimeTypesMap[FileType.Pdf] = 'application/pdf';
FiMimeTypesMap[FileType.Excel] = FiAppSettings.ExcelContentType + ', application/vnd.ms-excel';

export function getAcceptByFileType(fileTypes: number[], additionalMimeTypes): string {
    if (!isDefined(fileTypes)) {
        return undefined;
    }
    let mimeTypes: string[] = [];
    for (let i = 0; i < fileTypes.length; i++) {
        let mimeType = FiMimeTypesMap[fileTypes[i]];
        mimeTypes.push(mimeType);
    }
    if (additionalMimeTypes) mimeTypes = mimeTypes.concat(additionalMimeTypes);

    return mimeTypes.join(', ');
}
